import type { ReactElement } from 'react';
import { Tooltip } from '~/components/Tooltip';

/**
 * Wraps a button with a tooltip when a disabled reason is present. The span is required because
 * Tooltip can't bind events to a disabled element.
 *
 * `display` is configurable because the callers differ: inline-block keeps a button sitting in a
 * row, block lets a full-width menu item keep its width.
 */
export const withTooltip = (
  button: ReactElement,
  reason: string | undefined,
  display: 'block' | 'inline-block' | 'flex' = 'inline-block',
) =>
  reason ? (
    <Tooltip title={reason}>
      <span style={{ display }}>{button}</span>
    </Tooltip>
  ) : (
    button
  );
